import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

async function list(params) {
  return await request({
    url: ENDPOINT.APPROVED_DOCUMENTS,
    method: "get",
    params,
  });
}

async function show(id) {
  return await request({
    url: `${ENDPOINT.APPROVED_DOCUMENTS}/${id}`,
    method: "get",
  });
}

async function create(data) {
  return await request({
    url: ENDPOINT.APPROVED_DOCUMENTS,
    method: "post",
    data,
  });
}

async function update(data) {
  return await request({
    url: `${ENDPOINT.APPROVED_DOCUMENTS}/${data.id}`,
    method: "patch",
    data,
  });
}

async function remove(data) {
  return await request({
    url: `${ENDPOINT.APPROVED_DOCUMENTS}/${data.id}`,
    method: "delete",
    data,
  });
}

async function start(data = {
  document_id: "",
  document_type: "",
  notes: "",
  extra_data: {}
}, params = {
  contract_id: '',
  action_id: ''
}) {
  return await request({
    url: `${ENDPOINT.APPROVED_DOCUMENTS}/start`,
    method: "post",
    params,
    data,
  });
}

async function execute(data = {
  notes: "",
  extra_data: {}
}, url) {
  return await request({
    url: `${ENDPOINT.BACKEND_URL}${url}`,
    method: "post",
    data,
  });
}

export default {
  list,
  show,
  create,
  update,
  remove,
  start,
  execute
};
